import type { ValueAxisScales } from '@/shared/charts/time-series-chart/TimeSeriesChart.types';
import type { ValueRange } from '@/shared/charts/time-series-chart/value-axis/ValueRange.types';
import {
  type AxisGroupMember,
  resolveValueAxisRanges,
} from '@/shared/charts/time-series-chart/value-axis/resolveValueAxisRanges';

import { valueAxisVisuals } from '../config/chartVisuals';

type GroupAxis = {
  yAxisIndex: number;
  range: ValueRange;
};

function addAxisMargin({ min, max }: ValueRange, marginRatio: number): ValueRange {
  const margin = (max - min) * marginRatio;

  return { min: min - margin, max: max + margin };
}

export function resolveGroupAxes(
  members: AxisGroupMember[],
  valueAxisScales: ValueAxisScales | undefined
): Map<string, GroupAxis> {
  const dataRanges = resolveValueAxisRanges(members, valueAxisScales);

  return new Map(
    [...dataRanges].map(([groupId, dataRange], index) => {
      const marginRatio = valueAxisScales?.[groupId]?.marginRatio ?? valueAxisVisuals.marginRatio;

      return [groupId, { yAxisIndex: index, range: addAxisMargin(dataRange, marginRatio) }];
    })
  );
}

export function getGroupAxis(axes: ReadonlyMap<string, GroupAxis>, groupId: string): GroupAxis {
  const axis = axes.get(groupId);

  if (!axis) {
    throw new Error(`No value axis was resolved for axis group "${groupId}".`);
  }

  return axis;
}
